import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ContentNews } from 'src/app/models/obs/contentnews';
import { Log } from 'src/app/models/user-log';
import { ContentnewsService } from 'src/app/services/obs/contentnews.service';
import { NewsService } from 'src/app/services/obs/news.service';
import { UserLogService } from 'src/app/services/user-log.service';
import { UtilLogService } from 'src/app/services/util/util-log.service';

@Component({
  selector: 'app-admcontent-form',
  templateUrl: './admcontent-form.component.html',
  styleUrl: './admcontent-form.component.scss'
})
export class AdmcontentFormComponent implements OnInit {

  form: FormGroup;
  cnews: ContentNews = null;

  edit: boolean = false;
  idnewsSelected: string = null;

  movesLog: Log[] = null;

  term: string = 'parrafo';

  constructor(
    private router: Router,
    private newsS: NewsService,
    private cnewS: ContentnewsService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private userLogService: UserLogService,
    private utilLogservice: UtilLogService
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.createForm();
    this.getContent(params);
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      idnews: [null],
      content: ['', Validators.required],
      order: ['', Validators.required],
      status: []
    })
  }

  getContent(params: any) {
    if (params.id) {
      this.cnewS.getOne(params.id).subscribe({
        next: res => {
          this.cnews = res['data'];
          this.idnewsSelected = this.cnews.idnews;
          this.getType(this.idnewsSelected);
          this.loadData();
          this.edit = true;
        },
        error: err => console.error(err)
      });
    } else if (params.idnews) {
      this.idnewsSelected = params.idnews;
      this.edit = false;
    }
  }

  getType(idNewSelected: string) {
    this.newsS.getTypeNewOrEvent(idNewSelected).subscribe({
      next: res => {
        if (res) {
          /* this.term = res['data'].type ? 'eventos prospectivos' : 'contenido actualidad'; */
          this.getLog(this.idnewsSelected);
        }
      },
      error: err => { console.log("error : ", err); }
    })
  }

  loadData() {
    this.form.reset(this.cnews);
  }
  cancel() {
    console.log("Cancel");
    this.router.navigate(['/adm/contenido/list/' + this.idnewsSelected]);
  }

  save() {
    if (this.form.invalid) {
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);
      this.router.navigate(['/adm/contenido/list', this.idnewsSelected]);
    }
  }

  create(cnew: ContentNews) {
    delete cnew.id;
    cnew.idnews = this.idnewsSelected;
    this.cnewS.create(cnew).subscribe({
      next: res => {
        // Crear el log de actividad del usuario
        if (res) this.utilLogservice.createLog(res['data'], 'creación', this.term);
        this.router.navigate(['/adm/contenido/list/' + this.idnewsSelected]);
      },
      error: err => { console.error(err) }
    });
  }

  update(id: string, cnew: ContentNews) {
    const data = { ...cnew };
    delete cnew.id;
    this.cnewS.update(id, cnew).subscribe({
      next: res => {
        // Crear el log de actividad del usuario
        if (res) this.utilLogservice.createLog(data, 'edición', this.term);
        this.router.navigate(['/adm/contenido/list/' + this.idnewsSelected]);
      },
      error: err => { console.error(err) }
    });
  }

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }
  //devulve el log del elemento consultado  
  getLog(idparent: string) {
    const params = this.activedRoute.snapshot.params;
    const idContent = params['id'];
    this.userLogService.getLastLogByContent(idContent, this.term, idparent).subscribe({
      next: res => { this.movesLog = res['data'] || []; },
      error: err => console.error(err)
    });
  }

}
